import { createMutationHelper } from '@utils/swr'
import { type ProductSearchRequest } from '../types/apiRequest'
import { type ProductSearchResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const { useMutation } = createMutationHelper<FortuneApis['get']['productSearch'], ProductSearchResponse, ProductSearchRequest>({
  client: 'fortune',
  key: '/campaigns',
  fetcher: (_url, { client, arg }) => {
    const { code, page, per_page, query } = arg || {}
    const newUrl = `/campaigns/${code}/products/search?page=${page}&per_page=${per_page}&q=${query}`
    return client.get(newUrl)
  },
})

export const useApiSearchCampaignProduct = useMutation
